import { NextSeo } from 'next-seo';
import * as React from 'react';

import { Video } from '@/lib/videos';

import FAQSection from '@/components/landing/FAQSection';
import FeaturesSection, { Feature } from '@/components/landing/FeaturesSection';
import GetStartedSection from '@/components/landing/GetStartedSection';
import HeroSection from '@/components/landing/HeroSection';
import TestimonialsSection from '@/components/landing/TestimonialsSection';
import Layout from '@/components/layout/Layout';

const title = `Turn podcasts into viral clips (in seconds)`;
const ForPodcastersPage: React.FC<{ videos: Video[] }> = ({ videos }) => {
  return (
    <>
      <NextSeo title={title} />
      <Layout mode='light'>
        <main>
          <HeroSection
            pageType='For Podcasters'
            titleTop='Turn podcasts into viral'
            titleBottom='clips with one click'
            subtitle='We use AI to automatically find the best moments of your podcast and give you ready-to-post clips within minutes.'
          />
          {/*<DemoVideoSection />*/}
          <FeaturesSection>
            <Feature
              name='More time to create'
              // description="Spend your time creating new content, not making clips for past videos."
              // description="Spend less time making clips for past videos, and more time creating new content."
              description='Spend more time creating new content and less time making clips from past videos.'
              image='/images/faster-turnaround.png'
              alt='More time'
            />
            <Feature
              name='Reach new listeners'
              description='Clips are the best way to get discovered by new audiences.'
              image='/images/grow-audience-2.png'
              alt='Grow your audience'
              flipped
            />
            <Feature
              name='Cut production costs'
              description='Pay less than 10x the price of what it costs to hire an editor.'
              image='/images/lower-price-3.png'
              alt='Cut production costs'
            />
            <Feature
              name='Revive old episodes'
              description='Transform your past podcasts into engaging short videos and reach a broader audience.'
              image='/images/reuse-content.png'
              alt='Hero image'
              flipped
            />
          </FeaturesSection>
          <TestimonialsSection />
          <FAQSection />
          <GetStartedSection />
        </main>
      </Layout>
    </>
  );
};

export default ForPodcastersPage;
